import { createContext, useContext } from "react";

export type PlaybackRateState = {
  isEnabled: boolean;
  playbackRate: number;
  playbackRates?: number[];
};

export type PlaybackRateActions = {
  setPlaybackRate: (playbackRate: number) => void;
};

export const PlaybackRateContext = createContext<
  (PlaybackRateState & PlaybackRateActions) | undefined
>(undefined);

export const usePlaybackRate = (): PlaybackRateState & PlaybackRateActions => {
  const context = useContext(PlaybackRateContext);

  if (context === undefined) {
    throw new Error(
      "usePlaybackRate must be used within a PlaybackRateContextProvider"
    );
  }

  return context;
};
